import { render } from "./Show.vue?vue&type=template&id=006a4866"
import script from "./Show.vue?vue&type=script&lang=js"
export * from "./Show.vue?vue&type=script&lang=js"

import "./Show.vue?vue&type=style&index=0&id=006a4866&lang=css"

import exportComponent from "/var/www/vhosts/ecstatic-ride.91-210-227-178.plesk.page/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__